export default "__VITE_ASSET__BMg0sAbv__"